import React from "react";
import { TypeAnimation } from "react-type-animation";

export default function Hero() {
  return (
    <section id="hero" className="min-h-[90vh] flex items-center justify-center px-4 md:px-16 pt-16">
      <div className="text-center">
        <h1 className="text-4xl md:text-6xl font-bold mb-4">
          <TypeAnimation
            sequence={[
              "Aver Godwin",
              2000,
              "Aver Godwin.",
              1000,
            ]}
            speed={10}
            repeat={Infinity}
          />
        </h1>
        <p className="text-xl md:text-2xl text-gray-400">Welcome to my space</p>
        <p className="text-xl font-mono text-[#2bbc2b] mb-8">&gt; Fullstack Developer</p>
        <div className="max-w-2xl mx-auto text-base font-mono">
          <p className="text-[#FF5370] inline-block">&lt;body&gt;</p>
          <p className="inline"> I build apps that not only look good but also are a great experience for users. My focus is on creating secure, smooth, and reliable experiences that meet modern industry standards. </p>
          <p className="text-[#FF5370] inline">&lt;/body&gt;</p>
        </div>
      </div>
    </section>
  );
}